import { render, staticRenderFns } from "./TepInspeccionGestiona.vue?vue&type=template&id=4016996c"
import script from "./TepInspeccionGestiona.vue?vue&type=script&lang=js"
export * from "./TepInspeccionGestiona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports